export default __webpack_public_path__ + "static/media/cr_karier.c4bf0b73.png";